import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Prompt, Route } from 'react-router-dom';

import { RootState } from '../../configs/store';
import { LocationInterface, RouterInterface } from 'src/interfaces/RouterInterface';


interface GuardRouteProps {
    render: any,
    path: string | string[],
    exact?: boolean
  }

function GuardRoute({ render: Component, path, exact = true }: GuardRouteProps) {

  const [render, setRender] = useState(null);
  const dispatch = useDispatch();
  const { isDirty } = useSelector((state: RootState) => state.events);
  const { modal } = useSelector((state: RootState) => state.content);
  const location:LocationInterface = useSelector<RouterInterface>(state => state.router);

  useEffect(() => {
    if (!location.search || !render){
      setRender(<Component />);
    }
  }, [Component]);

  return (
    <Route
      exact={ exact }
      path={ path }
      render={
        () =>
          <>
            <Prompt
              when={ isDirty && modal === '' }
              message={
                (oldLocation) => {
                  if (location.pathname !== oldLocation.pathname) {
                    location.state = { next: oldLocation.pathname };
                    dispatch.content.modalType('#askConfirmation');
                    dispatch.events.changeDirtiness(false);
                    return false;
                  }

                  return true;
                }
              }
            />
            { render }
          </>
      }
    />
  );
}

export default GuardRoute;
